<app-navbar></app-navbar>
<div class="container">
      <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
            <div class="col" *ngFor="let i of favourite ">
               <app-card [card]="i" [heart]="heart"></app-card>
      </div>
  </div>
    </div>
  